var PastelIconos = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;
  var aux = {
    top: 80,
    right: 10,
    bottom: 30,
    left: 10
  };

  var radioCirculo = 12;
  var alturaRenglon = 50;

  (function() {
    datos.opciones = _.filter(datos.opciones, function(d) {
      return d.valor > 0;
    });
    var config = new Config(0, aux);
    var estilos = config.getEstilos();
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var barras = config.getBarrasHorizontales();
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var altura = _.max([radioCirculo, alturaRenglon]);
      altoVisualizacion = Math.floor((datos.opciones.length - 1) / 4) * 60;
      var margin = config.getMargin();
      var gMargin = config.getGMargin();
      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, aux);

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;
  var gLeyenda = null;
  var gPastel = null;

  var pie = d3.layout
    .pie()
    .sort(null)
    .value(function(d) {
      return d.pct;
    });

  var arc = d3.svg
    .arc()
    .outerRadius(200)
    .innerRadius(0);

  function arcTween(a) {
    var i = d3.interpolate(this._current, a);
    this._current = i(0);
    return function(t) {
      return arc(i(t));
    };
  }

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      gLeyenda = gGrafica.append("g");
      gPastel = gGrafica.append("g");

      ordenar();

      var colores = funciones.getColores(datos.opciones.length, 0.15);
      _.each(datos.opciones, function(o, i) {
        o.color = colores[i];
        o.pct = 0;
      });

      main();
    }
  }

  function ordenar() {
    var orden = el.data("orden") || false;
    if (orden !== false) {
      orden = orden.toLowerCase();
      switch (orden) {
        case "desc":
          datos.opciones.sort(ordenDescendente);
          break;
        default:
          break;
      }
    }
  }

  function main() {
    setLeyendas();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (debug === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    } else {
      if (el.visible() === true) {
        iniciar();
        $(window).off("scroll", revisaScroll);
      }
    }
  }

  function iniciar() {
    actualizaLeyendas();
    callback(null, true);
  }

  function setLeyendas() {
    var titulo = datos.titulo || false;
    if (titulo !== false) {
      svg
        .append("text")
        .style(estilos.titulo)
        .attr("x", 0)
        .attr("y", margin.top)
        .text(titulo)
        .call(funciones.wrap, gMedidas.ancho);
    }

    var altura = _.max([radioCirculo, alturaRenglon]);
    var ancho = 0;
    var escala = 1;
    var transportes = config.getTransportes();

    var pcts = funciones.getPorcentajes(_.map(datos.opciones, "valor"), total);
    _.each(pcts, function(p, i) {
      datos.opciones[i].valor = pcts[i];
    });
    ordenar();

    gLeyenda.attr("transform", "translate(64,0)");
    var renglones = gLeyenda.selectAll("g.renglon").data(datos.opciones);
    renglones
      .enter()
      .append("g")
      .attr("class", "renglon")
      .attr("fill", function(d) {
        return d.color;
      })
      .attr("transform", function(d, i) {
        var x = (i % 4) * 240;
        var y = Math.floor(i / 4) * 60;
        return "translate(" + [x, y] + ")";
      });

    renglones
      .append("text")
      .style(config.getPastel())
      .style("opacity", 0)
      .text(function(d) {
        var v = parseInt(d.valor);
        if (v < 1) {
          v = "<1";
        }
        return v + "%";
      })
      .attr("transform", "translate(" + radioCirculo + ",0)");

    /*
    renglones
      .append("circle")
      .attr("cx", radioCirculo + 15)
      .attr("cy", radioCirculo)
      .attr("r", radioCirculo);
      */

    renglones
      .append("path")
      .attr("class", "transporte")
      .attr("d", function(d) {
        return d.ruta;
      })
      .attr("transform", "scale(" + escala + ")")
      .attr("fill", transportes.fondo)
      .each(function(d) {
        var caja = this.getBBox();
        d.caja = caja;
        ancho = _.max([ancho, (caja.width - caja.x) * escala]);
      })
      .attr("transform", function(d) {
        var x = -d.caja.x * escala + radioCirculo + 30;
        var y = (d.caja.height / 2 + d.caja.y) * escala - radioCirculo;
        return "translate(" + x + "," + -y + ")scale(" + escala + ")";
      });
  }

  function generaPastel() {
    gPastel.attr("transform", "translate(" + 280 + "," + 200 + ")");
    gPastel
      .selectAll("path.arc")
      .data(pie(datos.opciones))
      .enter()
      .append("path")
      .attr("fill", function(d, i) {
        return d.data.color;
      })
      .attr("d", arc)
      .attr("class", "arc")
      .each(function(d) {
        this._current = d;
      })
      .style("stroke", "#ffffff");
  }

  function actualizaPastel() {
    _.each(datos.opciones, function(o) {
      o.pct = (o.valor * 100) / total;
    });
    gPastel
      .selectAll("path.arc")
      .data(pie(datos.opciones))
      .transition()
      .duration(800)
      .attrTween("d", arcTween);
  }

  function actualizaLeyendas() {
    gLeyenda
      .selectAll("text")
      .style("opacity", 0)
      .transition()
      .duration(800)
      .style("opacity", 1);
  }

  function ordenDescendente(a, b) {
    if (a.valor < b.valor) {
      return 1;
    }
    if (a.valor > b.valor) {
      return -1;
    }
    return 0;
  }

  setup();
};
